import React, { Component } from 'react';
import { Divider, Pagination, Select, Spin } from 'antd';
import { createCoreServiceUrl } from 'commons/services';
import axios, { AxiosResponse } from 'axios';
import { SelectValue } from 'antd/lib/select';

type Props = {
  url: string;
  size: number;
  onChange: (value: SelectValue) => void;
};

class PaginatedSelect extends Component<Props> {
  public state = {
    options: [],
    currentPage: 0,
    fetching: false,
    total: 0,
  };

  private searched = '';
  private isTypingTimer: any;

  public componentDidMount(): void {
    this.fetchOptions(0, '');
  }

  public handleSearch = (value: string) => {
    clearTimeout(this.isTypingTimer);
    this.isTypingTimer = setTimeout(() => {
      this.fetchOptions(0, value);
    }, 1000);

    this.searched = value;
  };

  public fetchOptions = (page: number, searched: string) => {
    this.setState({ fetching: true });
    const { url, size } = this.props;
    axios
      .get(createCoreServiceUrl(url), {
        params: { page, size, searched },
      })
      .then((response: AxiosResponse<any>) => {
        this.setState({
          options: response.data.content,
          currentPage: response.data.number,
          total: response.data.totalElements,
        });
      })
      .catch(() => {
        // no-op
      })
      .finally(() => {
        this.setState({ fetching: false });
      });
  };

  public render = (): React.ReactNode => {
    const { size, onChange } = this.props;
    const { options, fetching, currentPage, total } = this.state;
    return (
      <Select
        // defaultActiveFirstOption
        defaultValue="ALL"
        showSearch
        loading={fetching}
        style={{ width: '100%' }}
        onChange={(value) => {
          if (value == 'ALL') {
            this.searched = '';
            this.fetchOptions(0, '');
          }
          onChange(value);
        }}
        dropdownRender={(menu) => (
          <div>
            {menu}
            <Divider style={{ margin: '4px 0' }} />
            <div
              onMouseDown={(e) => e.preventDefault()}
              style={{ padding: '8px', textAlign: 'center' }}
            >
              <Pagination
                disabled={fetching}
                style={{ fontSize: 12 }}
                simple
                size="small"
                showLessItems
                current={currentPage + 1}
                total={total}
                pageSize={size}
                onChange={(pageIndex) => {
                  this.fetchOptions(pageIndex - 1, this.searched);
                }}
              />
            </div>
          </div>
        )}
        onSearch={(value: string) => this.handleSearch(value)}
        notFoundContent={fetching ? <Spin size="small" /> : null}
      >
        <Select.Option value={'ALL'}>Todos</Select.Option>
        {options.map((item: string) => (
          <Select.Option key={item} value={item}>
            {item}
          </Select.Option>
        ))}
      </Select>
    );
  };
}

export default PaginatedSelect;
